import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash/isNil';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

import { tooltipPositions } from '../_constants/tooltipPositions';

import { styles } from './ArrowTooltipStyles';

import theme from './ArrowTooltip.scss';

const normalize = (str) => str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();

class ArrowTooltip extends React.Component {
  constructor(props) {
    super(props);

    const { tooltipPlacement, isRtl } = props;

    this.state = {
      arrowRef: null,
      placement: isRtl
        ? this.flipPlacement(normalize(tooltipPlacement))
        : normalize(tooltipPlacement),
    };
  }

  handleArrowRef = node => {
    this.setState({
      arrowRef: node,
    });
  };

  flipPlacement = (placement) => {
    const [verticalPos, horizontalPos] = placement.split('-');

    if (isNil(horizontalPos)) {
      return verticalPos;
    }

    return `${ verticalPos }-${ horizontalPos === 'end' ? 'start' : 'end' }`;
  };

  render() {
    const {
      classes,
      children,
      title,
      isRtl,
      disabled,
      disableArrowOffset,
      verticalOffset,
      horizontalOffset,
    } = this.props;

    const { placement } = this.state;

    if (!children && !title) {
      return null;
    }

    if (disabled) return children;

    return (
      <Tooltip
        placement={ placement }
        title={ (
          <React.Fragment>
            <div
              className={ isRtl ? theme.tooltipRtl : theme.tooltip }
            >
              <span>{ title }</span>
            </div><span className={ classes.arrow } ref={ this.handleArrowRef } />
          </React.Fragment>
        ) }
        classes={{
          tooltip: classes.htmlTooltip,
          popper: classes.htmlPopper,
        }}
        PopperProps={{
          popperOptions: {
            transition: false,
            modifiers: {
              arrow: {
                enabled: Boolean(this.state.arrowRef),
                element: this.state.arrowRef,
              },
              offset: {
                enabled: !disableArrowOffset,
                offset: `${ !isRtl ? '-' : '' }${ horizontalOffset }px, ${ verticalOffset }px`,
              },
            },
          },
        }}
      >
        { children }
      </Tooltip>
    );
  }
}

ArrowTooltip.propTypes = {
  classes: PropTypes.shape({
    arrow: PropTypes.string.isRequired,
    htmlTooltip: PropTypes.string.isRequired,
    htmlPopper: PropTypes.string.isRequired,
  }),
  children: PropTypes.element.isRequired,
  tooltipPlacement: PropTypes.oneOf(Object.keys(tooltipPositions)),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isRtl: PropTypes.bool,
  disabled: PropTypes.bool,
  disableArrowOffset: PropTypes.bool,
  verticalOffset: PropTypes.number,
  horizontalOffset: PropTypes.number,
};

ArrowTooltip.defaultProps = {
  tooltipPlacement: tooltipPositions.top,
  classes: {
    arrow: '',
    htmlTooltip: '',
    htmlPopper: '',
  },
  title: '',
  isRtl: false,
  disabled: false,
  disableArrowOffset: false,
  verticalOffset: 5,
  horizontalOffset: 0,
};

export default withStyles(styles)(ArrowTooltip);
